import { TagNFeEntrada } from '../../../../../shared/services/models/repo-dfe/tag-nfe-entrada.model';

export class AlterarTagsNotaFiscalEntradaDialogData {
  idsNFeEntrada: number[];
  tags: TagNFeEntrada[];
  idsTagsAtuais: number[];
}
